export const BumpType = {
  NONE: 0,
  CPFP: 1,
  RBF: 2,
}
